<template>
    <div class="">
        <div class="orderItem">
            <div class="serviceGroup">
                <div class="serviceItem">
                    <div class="itemLabel">Service Items</div>
                    <div class="price">${{ list.total_price || list.price }}</div>
                </div>
                <div class="serviceItem">
                    <div class="itemLabel">Staff</div>
                    <div>{{ formatTimestamp(list.start_time,'MMMM, dddd DD YYYY', timezone) }}</div>
                </div>
                <div class="serviceItem">
                    <div class="technicianInfo">
                        <div>Staff:</div>
                        <div class="userName">{{ (list.technician && list.technician.name) || list.technician_name || 'Staff' }}</div>
                    </div>
                    <div>{{ formatTimestamp(list.start_time,'hh:mm A', timezone) }}-{{ formatTimestamp(list.end_time,'hh:mm A', timezone)}}</div>
                </div>
                <div class="serviceItem waitingTime" v-if="list.waiting_time">
                    <div>⏱ WAITING TIME: {{ list.waiting_time }} Min</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myMixin  from '@/utils/myMixin'
export default {
    name:'PayOrderList',
    data(){
        return {
        }
    },
    props:{
        list:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        total_price:{
            type:String,
            default:''
        },
        showTechnicianAvatar: {
            type: Boolean,
            default: true
        },
        timezone: {
            type: String,
            default: ''
        }
    },
    mixins:[myMixin],
}
</script>
<style lang="scss" scoped>
.orderList{
    .orderItem{
        display: flex;
        flex-direction: column;
        .serviceGroup{
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            .serviceItem{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.8rem;
                color: #666666;
                font-size: .875rem;
                &:last-child{
                    margin-bottom: 0;
                }
                .technicianInfo{
                    display: flex;
                    align-items: center;
                }
            }
            .serviceInfo{
                font-size: .75rem;
                .userName{
                    margin: 0.25rem 0;
                }
            }
            .serviceTime{
                text-align: right;
                font-size: .875rem;
                .price{
                    margin: 0.25rem 0;
                }
            }
        }
    }
}
.serviceGroup {
    width: 100%;
    .serviceItem {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        color: #666666;
        font-size: .875rem;
        &:last-child {
            margin-bottom: 0;
        }
        .itemLabel {
            color: #333;
        }
        .price {
            font-weight: bold;
            color: #333;
        }
        .technicianInfo {
            display: flex;
            align-items: center;
            .userName {
                margin-left: 0.25rem;
            }
        }
    }
    .waitingTime {
        justify-content: flex-start;
        color: #999;
        font-size: 0.75rem;
    }
}
</style>
